import { useApiClient } from '@m43/core';
import { useMutation } from '@tanstack/react-query';
import { DexFirearmFormBootstrapView, FirearmInquiry } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { DexForm } from './dex-form';
import { DexFormModel } from '../types';
import { pruneDexFields } from '../utils';
import { DexQueriessubmitResource, DexQuerySubmissionFirearmInquiry } from '@mark43/dex-api';
import { useIsLinkToAssignedEventCheckboxVisible } from './use-is-link-to-assigned-even-visible';
import { EventWorkspacePanelDexFormPrefill } from '../../panels/workspace-panel-types';
import { useBuildDexQuerySubmission } from './use-build-dex-query-submission';
import { useResetValuesAfterOriAliasChange } from './use-reset-values-after-ori-alias-change';
import { useResetDexFormOnPrefillValuesUpdate } from './use-reset-dex-form-on-prefill-values-update';

export function DexFirearmForm({
    formBootstrapView,
    dexFormEventPanelPrefillValues,
}: {
    formBootstrapView: DexFirearmFormBootstrapView;
    dexFormEventPanelPrefillValues?: EventWorkspacePanelDexFormPrefill;
}): React.ReactElement {
    const apiClient = useApiClient();
    const isLinkToAssignedEventCheckboxVisible = useIsLinkToAssignedEventCheckboxVisible();
    const defaultValues = {
        params: {
            ...formBootstrapView.defaultValues,
            ...(pruneDexFields(formBootstrapView, dexFormEventPanelPrefillValues?.firearm) ?? {}),
        },
        requestingUnitOption: null,
        agencyEventOption: null,
        ...(isLinkToAssignedEventCheckboxVisible ? { linkToAssignedEvent: true } : null),
    };
    const form = useForm<DexFormModel<FirearmInquiry>>({
        mode: 'onBlur',
        defaultValues,
    });

    useResetValuesAfterOriAliasChange({
        formInitalValues: formBootstrapView.defaultValues,
        form,
        defaultValues,
    });

    useResetDexFormOnPrefillValuesUpdate({
        form,
        prefillValues: dexFormEventPanelPrefillValues?.firearm,
    });

    const buildDexQuerySubmission = useBuildDexQuerySubmission(
        form,
        formBootstrapView.dexFormView.dexQuery
    );
    const sendQueryMutation = useMutation((formModel: DexFormModel<FirearmInquiry>) => {
        return apiClient.request<DexQueriessubmitResource.SubmitFirearmQuery>({
            service: 'DEX',
            method: 'POST',
            url: 'dex_queries/submit/firearm_inquiry',
            data: buildDexQuerySubmission(formModel) as DexQuerySubmissionFirearmInquiry,
        });
    });
    return (
        <DexForm
            eventNumber={dexFormEventPanelPrefillValues?.eventNumber}
            dexFormView={formBootstrapView.dexFormView}
            defaultParams={formBootstrapView.defaultValues}
            form={form}
            sendQueryMutation={sendQueryMutation}
        />
    );
}
